<!-- Header -->
<h3 mat-dialog-title translate>
    Select Recipients
</h3>

<!-- Body -->
<mat-dialog-content>

    <!-- Row alignment -->
    <div style="display: flex">

        <!-- Selections -->
        <div>

            <!-- Term Selection -->
            <div translate>List teachers for</div>
            <div>
                <tyl-radio-group [values]="[1, 2, 3]" [labels]="[
                        'Today\'s Schedule',
                        'This Term',
                        'All Year'
                    ]" [ids]="[
                        'todayRadio',
                        'termRadio',
                        'allRadio'
                    ]" [(selected)]="viewOption" [attr.aria-label]="'list teachers for term'" arrange="vertical">
                </tyl-radio-group>
            </div>

            <!-- Persons Selection -->
            <ng-container *ngIf="!V10">
                <div style="margin-top: 15px;" translate>
                    Also list
                </div>
                <div class="columnFlex">
                    <tyl-checkbox [(checked)]="allAdvisors">
                        <span translate>All Advisors</span>
                    </tyl-checkbox>
                    <tyl-checkbox [(checked)]="allCoTeachers" *ngIf="!V10">
                        <span translate>All Co-Teachers</span>
                    </tyl-checkbox>
                    <tyl-checkbox [(checked)]="allCounselors">
                        <span translate>All Counselors</span>
                    </tyl-checkbox>
                    <tyl-checkbox [(checked)]="allPrincipals">
                        <span translate>All Principals</span>
                    </tyl-checkbox>
                    <tyl-checkbox *ngIf="userType == 1" [(checked)]="allSiteAdministrators">
                        <span translate>All Site Administrators</span>
                    </tyl-checkbox>
                    <tyl-checkbox *ngIf="userType == 1" [(checked)]="allDistrictAdministrators">
                        <span translate>All District Administrators</span>
                    </tyl-checkbox>
                    <tyl-checkbox [(checked)]="allNurses">
                        <span translate>All Nurses</span>
                    </tyl-checkbox>
                </div>
            </ng-container>
        </div>

        <!-- Display Table -->
        <div [ngStyle]="{'height': getScreenHeight() + 'px', 'overflow':'auto'}"
            style="padding: 0 10px 0 0; flex-grow: 1;">
            <mat-table *ngIf="tableData" [dataSource]="tableData">

                <!-- To Column -->
                <ng-container matColumnDef='to'>
                    <mat-header-cell *matHeaderCellDef translate>
                        To
                    </mat-header-cell>
                    <mat-cell *matCellDef="let recipient">
                        <tyl-checkbox *ngIf="canSendTo(recipient)" [checked]="toSelections.includes(recipient.Id)"
                            (change)="toggleSelection(recipient, toSelections)"></tyl-checkbox>
                    </mat-cell>
                </ng-container>

                <!-- CC Column -->
                <ng-container matColumnDef='CC'>
                    <mat-header-cell *matHeaderCellDef translate>
                        CC
                    </mat-header-cell>
                    <mat-cell *matCellDef="let recipient">
                        <tyl-checkbox [disabled]="!canCCTo(recipient)" [checked]="CCSelections.includes(recipient.Id)"
                            (change)="toggleSelection(recipient, CCSelections, true)"></tyl-checkbox>
                    </mat-cell>
                </ng-container>

                <!-- BCC Column -->
                <ng-container matColumnDef='BCC'>
                    <mat-header-cell *matHeaderCellDef translate>
                        BCC
                    </mat-header-cell>
                    <mat-cell *matCellDef="let recipient">
                        <tyl-checkbox [checked]="BCCSelections.includes(recipient.Id)"
                            (change)="toggleSelection(recipient, BCCSelections, true, true)"></tyl-checkbox>
                    </mat-cell>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef='name'>
                    <mat-header-cell *matHeaderCellDef translate>
                        Name
                    </mat-header-cell>
                    <mat-cell *matCellDef="let recipient">
                        {{recipient.Name}}
                    </mat-cell>
                </ng-container>

                <!-- Relationship Column -->
                <ng-container matColumnDef='relationship'>
                    <mat-header-cell *matHeaderCellDef translate>
                        Relationship
                    </mat-header-cell>
                    <mat-cell *matCellDef="let recipient">
                        <div *ngIf="V10">
                            <ng-container *ngIf="recipient.Relationship == 'Teacher'">
                                <div *ngFor="let course of recipient.CourseList" class="relationshipString">
                                    Teacher - {{course}}
                                </div>
                            </ng-container>
                            <div *ngIf="recipient.Relationship != 'Teacher'">
                                {{recipient.Relationship}}
                            </div>
                        </div>
                        <div *ngIf="!V10">
                                <ng-container *ngIf="recipient.UserType == '1'">
                                    <div *ngFor="let course of recipient.RelationshiptCourseList" class="relationshipString">
                                        {{course}}
                                    </div>
                                    <div *ngIf="recipient.RelationshiptCourseList.length == 0">
                                            {{recipient.Relationship}}
                                        </div>
                                </ng-container>
                                <div *ngIf="recipient.UserType != '1'">
                                    {{recipient.Relationship}}
                                </div>
                            </div>
                    </mat-cell>
                </ng-container>

                <!-- Row Definitions -->
                <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: columns;" matRipple></mat-row>
            </mat-table>
<div *ngIf="userType == 1">
    Additional
<div style="margin-top: 10px; margin-bottom: 15px;">
    <tyl-form-field label='To' [hintLabel]="'Separate addresses with semicolons.'" [fullWidth]="true"
                    style="width:100%;">
        <input matInput [(ngModel)]="additionalTo" id='inpTo' type='text'/>
    </tyl-form-field>
</div>
<div style="margin-top: 10px; margin-bottom: 15px;">
    <tyl-form-field label='CC' [hintLabel]="'Separate addresses with semicolons.'" [fullWidth]="true"
                    style="width:100%;">
        <input matInput [(ngModel)]="additionalCc" id='inpCC' type='text'/>
    </tyl-form-field>
</div>
<div style="margin-top: 10px; margin-bottom: 15px;">
    <tyl-form-field label='BCC' [hintLabel]="'Separate addresses with semicolons.'" [fullWidth]="true"
                    style="width:100%;">
        <input matInput [(ngModel)]="additionalBcc" id='inpBCC' type='text'/>
    </tyl-form-field>
</div>
</div>

        </div>
    </div>
</mat-dialog-content>



<!-- Footer -->
<mat-dialog-actions style="position: sticky">
    <div class="flex-footer-left">
        <tyl-button image="DeSelectAll.png" label="Deselect All" (clickEvent)="deselectAll()"></tyl-button>
    </div>
    <div class="flex-footer-right">
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="save.png" label="OK" (clickEvent)="ok()"></tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancel()"></tyl-button>
    </div>
</mat-dialog-actions>
